export enum GraphQLErrors {
  INVALID_USERNAME_PASSWORD = "INVALID_USERNAME_PASSWORD",
  UNAUTHORIZED = "E_UNAUTHORIZED",
  ACCOUNT_REQUIRED = "X_ACCOUNT_REQUIRED",
  ACL_PERMS = "ACL_PERMS",
  VALIDATION_FAILED = "VALIDATION_FAILED"
}
